// SolisRestore scope rail controller.
// Narrows the product grid by product.type, in place, over the single ul[ref="grid"].
// Loaded as a module (deferred) by snippets/solis-collection-scope.liquid, so the grid
// exists by the time this runs. Survives infinite-scroll appends via a MutationObserver
// and the theme's 'filter:update' event. Keeps focus on the chips; announces via aria-live.
(function () {
  var scope = document.querySelector('[data-sr-scope]');
  if (!scope) return;

  var list = document.getElementById('the-edit');
  var grid = (list && list.querySelector('[ref="grid"]')) || document.querySelector('.product-grid');
  if (!grid || !(grid instanceof Node)) return;

  var chips = Array.prototype.slice.call(scope.querySelectorAll('.sr-scope__chip'));
  var liveEl = scope.querySelector('[data-sr-live]');
  var active = 'all';

  function labelFor(type) {
    var chip = scope.querySelector('.sr-scope__chip[data-type="' + type + '"]');
    if (!chip) return '';
    var clone = chip.cloneNode(true);
    var count = clone.querySelector('.sr-scope__count');
    if (count) { count.parentNode.removeChild(count); }
    return (clone.textContent || '').trim();
  }

  function ensureEmpty(show) {
    var node = grid.parentNode.querySelector('[data-sr-empty]');
    if (show && !node) {
      node = document.createElement('div');
      node.setAttribute('data-sr-empty', '');
      node.className = 'sr-scope__empty';
      node.innerHTML = 'Nothing in this scope yet. <a class="sr-text-cta" href="/pages/contact">Speak with Solis</a>';
      grid.parentNode.insertBefore(node, grid.nextSibling);
    } else if (!show && node) {
      node.parentNode.removeChild(node);
    }
  }

  function apply(announce) {
    var items = grid.querySelectorAll('.product-grid__item');
    var shown = 0;
    for (var i = 0; i < items.length; i++) {
      var match = active === 'all' || items[i].getAttribute('data-scope-key') === active;
      items[i].hidden = !match;
      if (match) { shown++; }
    }
    chips.forEach(function (chip) {
      var on = chip.getAttribute('data-type') === active;
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    ensureEmpty(shown === 0);
    if (announce && liveEl) {
      liveEl.textContent = active === 'all'
        ? ('Showing all ' + items.length)
        : ('Showing ' + shown + ' of ' + items.length + ', ' + labelFor(active));
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      active = chip.getAttribute('data-type');
      apply(true);
    });
  });

  document.addEventListener('filter:update', function () { apply(false); });
  if (window.MutationObserver && grid.nodeType === Node.ELEMENT_NODE) {
    new MutationObserver(function () { apply(false); }).observe(grid, { childList: true });
  }

  apply(false);
})();
